import { StaticQuery, graphql } from 'gatsby'
import { Link } from '../components/localizedlink'
import React from 'react'
import Img from 'gatsby-image'
import { slugify } from '../utils';
import { FormattedMessage } from 'react-intl';

const InterventiProgramma = ({ interventi }) => (
    <StaticQuery
        query={graphql`
            query {
                plaxceholder: file(relativePath: {eq: "contents/evento_plaxceholder.png"}){
                    childImageSharp{
                        fluid{
                            ...GatsbyImageSharpFluid
                        }
                    }
                }
            
            }
        `}
        render={data => {
            const intervento = interventi[0];
            const secondoIntervento = interventi[1];
            const terzoIntervento = interventi[2];
            let offset = "col-sm-offset-4";
            if (terzoIntervento) {
                offset = "";
            } else if (secondoIntervento) {
                offset = "col-sm-offset-2";
            }
          
            return (
                <section id="interventi-programma" className="section interventi-programma text-center" aria-labelledby="region2" data-aos="fade-up">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 col-md-10 col-md-offset-1">
                                <h1 id="region2" className="section__title">
                                    <FormattedMessage id="interventi-programma" />
                                </h1>
                                <div className="row">
                                    <div className={`col-sm-4 ${offset}`}>
                                        <div className="person">
                                            <Link to={`/${intervento.pageslug}/`} title={intervento.title} className="person__link">
                                                <figure className="person__figure">
                                                    <Img fluid={data.plaxceholder.childImageSharp.fluid} alt={intervento.title} className="person__img" />
                                                    <div className="person__bullet">
                                                        <span className={slugify(intervento.tipologia)}></span>
                                                    </div>
                                                    <div className="person__program"><span className={slugify(intervento.tipologia)}>{intervento.tipologia}</span></div>
                                                </figure>
                                                <span className="person__name">{intervento.title}</span>
                                                <span className="person__role">{intervento.luogo} | {intervento.day}, {intervento.orariodesc ? intervento.orariodesc : intervento.orario }</span>
                                                <span className="person__detail"><FormattedMessage id="continua>" /></span>
                                            </Link>
                                        </div>
                                    </div>
                                    {!!secondoIntervento && (
                                        <div className="col-sm-4">
                                            <div className="person">
                                                <Link to={`/${secondoIntervento.pageslug}/`} title={secondoIntervento.title} className="person__link person__link--last">
                                                    <figure className="person__figure">
                                                        <Img fluid={data.plaxceholder.childImageSharp.fluid} alt={secondoIntervento.title} className="person__img" />
                                                        <div className="person__bullet"><span className={secondoIntervento.tipologia.toLowerCase()}></span></div>
                                                        <div className="person__program"><span className={secondoIntervento.tipologia.toLowerCase()}>{secondoIntervento.tipologia}</span></div>
                                                    </figure>
                                                    <span className="person__name">{secondoIntervento.title}</span>
                                                    <span className="person__role">{secondoIntervento.luogo} | {secondoIntervento.day}, {secondoIntervento.orariodesc ? secondoIntervento.orariodesc : secondoIntervento.orario }</span>
                                                    <span className="person__detail"><FormattedMessage id="continua>"/></span>
                                                </Link>
                                            </div>
                                        </div>
                                    )}
                                    {!!terzoIntervento && (
                                        <div className="col-sm-4">
                                            <div className="person">
                                                <Link to={`/${terzoIntervento.pageslug}/`} title={terzoIntervento.title} className="person__link person__link--last">
                                                    <figure className="person__figure">
                                                        <Img fluid={data.plaxceholder.childImageSharp.fluid} alt={terzoIntervento.title} className="person__img" />
                                                        <div className="person__bullet"><span className={terzoIntervento.tipologia.toLowerCase()}></span></div>
                                                        <div className="person__program"><span className={terzoIntervento.tipologia.toLowerCase()}>{terzoIntervento.tipologia}</span></div>
                                                    </figure>
                                                    <span className="person__name">{terzoIntervento.title}</span>
                                                    <span className="person__role">{terzoIntervento.luogo} | {terzoIntervento.day}, {terzoIntervento.orariodesc ? terzoIntervento.orariodesc : terzoIntervento.orario }</span>
                                                    <span className="person__detail"><FormattedMessage id="continua>"/></span>
                                                </Link>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )
        }
        }
    />
);

export default InterventiProgramma;
